var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2383 2.50078C14.4572 2.28191 14.717 2.10829 15.003 1.98984C15.2889 1.87139 15.5954 1.81042 15.9049 1.81042C16.2145 1.81042 16.521 1.87139 16.8069 1.98984C17.0929 2.10829 17.3527 2.28191 17.5716 2.50078C17.7905 2.71965 17.9641 2.97949 18.0826 3.26545C18.201 3.55142 18.262 3.85792 18.262 4.16745C18.262 4.47698 18.201 4.78347 18.0826 5.06944C17.9641 5.35541 17.7905 5.61524 17.5716 5.83411L6.32161 17.0841L1.73828 18.3341L2.98828 13.7508L14.2383 2.50078Z",
    stroke: "#262626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c5c06abe03627b8ecbe66808b6ca5d40.svg";
export { ForwardRef as ReactComponent };